export default __webpack_public_path__ + "static/media/bedroom-reverse.f928158c.mp4";